export default {
  VITE_CREATIVE_HUB_API_URL:
    (import.meta.env.VITE_CREATIVE_HUB_API_URL as string) ??
    "http://localhost:7777/graphql"
};
